import { EventEmitter, QueryList } from '@angular/core';
import { ReferenceDataService } from '../../../../../services/reference-data/reference-data.service';
import { AutoGroupFilterList, GenderEnum } from '../../../../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { ValidationError } from '../../../../../../models/ErrorTemplate';
import { AutoGroupFilter, AutoGroupFilterConfig, AutoGroupFilterEnum } from '../../../../../../models/auto-group/auto-group-setting';
import { AppSettings } from '../../../../../utils/app-settings';
import { AutoGroupFilterBoxComponent } from '../../auto-group-filter-box/auto-group-filter-box.component';
var AutoGroupFilterItemComponent = /** @class */ (function () {
    function AutoGroupFilterItemComponent(referenceDataService, translate) {
        var _this = this;
        this.referenceDataService = referenceDataService;
        this.translate = translate;
        this.supportedFilterOptions = [];
        this.autoGroupFilter = new AutoGroupFilter();
        this.deleteGroupFilterEvent = new EventEmitter();
        this.changeGroupFilterEvent = new EventEmitter();
        this.changePlatformFilterEvent = new EventEmitter();
        // filter selections
        this.countries = [];
        this.genders = [];
        this.audienceGenders = [];
        this.activePlatforms = [];
        this.firstFilterValues = [];
        this.secondFilterValues = [];
        this.operatorList = [];
        this.countries = referenceDataService.countries.map(function (c) { return ({
            id: c.id,
            name: c.name,
            value: c.name
        }); });
        var maleObserver = translate.get('new_group_settings.auto_group_filters.male');
        maleObserver.subscribe(function (male) {
            var female = translate.instant('new_group_settings.auto_group_filters.female');
            var onlineMedia = translate.instant('new_group_settings.auto_group_filters.online_media');
            _this.genders = [
                {
                    name: female,
                    id: GenderEnum.FEMALE,
                    value: female
                },
                {
                    name: male,
                    id: GenderEnum.MALE,
                    value: male
                },
                {
                    name: onlineMedia,
                    id: GenderEnum.ONLINE_MEDIA,
                    value: onlineMedia
                }
            ];
            _this.audienceGenders = [
                {
                    name: female,
                    id: GenderEnum.FEMALE,
                    value: female
                },
                {
                    name: male,
                    id: GenderEnum.MALE,
                    value: male
                }
            ];
        });
        this.activePlatforms = this.referenceDataService.platforms.filter(function (platform) { return AppSettings.getActivePlatformList().indexOf(platform.name.toLowerCase()) >= 0; })
            .map(function (p) { return ({
            id: p.id,
            name: p.name,
            value: p.name
        }); });
    }
    AutoGroupFilterItemComponent.prototype.ngOnInit = function () {
        if (this.autoGroupFilter.type) {
            var filterConfig = AutoGroupFilterConfig[this.autoGroupFilter.type];
            this.isMultipleSelect = filterConfig && filterConfig.multiple;
            this.firstFilterValues = this.getFirstFilterValues(this.autoGroupFilter.type);
            this.secondFilterValues = this.getSecondFilterValues(this.autoGroupFilter.type);
        }
    };
    AutoGroupFilterItemComponent.prototype.selectFilter = function () {
        this.autoGroupFilter.comparison = null;
        this.changeGroupFilterEvent.emit(this.autoGroupFilter);
        var filterConfig = AutoGroupFilterConfig[this.autoGroupFilter.type];
        this.isMultipleSelect = filterConfig && filterConfig.multiple;
        if (this.isMultipleSelect) {
            this.autoGroupFilter.secondValue = [];
        }
        else {
            this.autoGroupFilter.secondValue = null;
        }
        this.firstFilterValues = this.getFirstFilterValues(this.autoGroupFilter.type);
        this.secondFilterValues = this.getSecondFilterValues(this.autoGroupFilter.type);
        this.clearAllFieldErrors();
    };
    AutoGroupFilterItemComponent.prototype.selectComparison = function (evt) {
        this.changeGroupFilterEvent.emit(this.autoGroupFilter);
        this.checkAndClearPreviousErrors();
    };
    AutoGroupFilterItemComponent.prototype.deleteGroupFilter = function () {
        this.deleteGroupFilterEvent.emit(this.autoGroupFilter);
    };
    AutoGroupFilterItemComponent.prototype.getSecondFilterValues = function (filterType) {
        var _this = this;
        switch (filterType) {
            case AutoGroupFilterEnum.COUNTRY:
            case AutoGroupFilterEnum.AUDIENCE_COUNTRY:
                return this.countries;
            case AutoGroupFilterEnum.INFLUENCER_GENDER:
                return this.genders;
            case AutoGroupFilterEnum.AUDIENCE_GENDER:
                return this.audienceGenders;
            case AutoGroupFilterEnum.AUDIENCE_AGE:
                return AutoGroupFilterList.audienceAgeList.map(function (item) {
                    var ageOption = _this.translate.instant('new_group_settings.auto_group_filters.audiencer_age_list', { audienceAgeValue: item.value });
                    return {
                        id: item.id,
                        name: ageOption,
                        value: ageOption
                    };
                });
            case AutoGroupFilterEnum.AVG_REACH_PER_POST:
            case AutoGroupFilterEnum.AVG_ENGAGEMENT_PER_POST:
            case AutoGroupFilterEnum.AVG_INTERACTION_PER_POST:
            case AutoGroupFilterEnum.FOLLOWERS:
                return AutoGroupFilterList.autoGroupValueList.map(function (item) { return ({
                    id: item.id,
                    name: item.name,
                    value: item.name
                }); });
            case AutoGroupFilterEnum.PLATFORM:
                return this.activePlatforms;
            default:
                return [];
        }
    };
    AutoGroupFilterItemComponent.prototype.updateOperatorList = function (operatorList) {
        this.operatorList = operatorList;
        var filterConfig = AutoGroupFilterConfig[this.autoGroupFilter.type];
        if (filterConfig.comparison.length === 1 && this.operatorList.length > 0) {
            this.autoGroupFilter.comparison = this.operatorList[0].id;
        }
    };
    Object.defineProperty(AutoGroupFilterItemComponent.prototype, "hasMultipleValues", {
        get: function () {
            var filterConfig = AutoGroupFilterConfig[this.autoGroupFilter.type];
            return filterConfig && filterConfig.numOfCol === AutoGroupFilterList.multipleValueColumn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoGroupFilterItemComponent.prototype, "hasMultipleComparison", {
        get: function () {
            var filterConfig = AutoGroupFilterConfig[this.autoGroupFilter.type];
            return this.operatorList.length > 0 && filterConfig && filterConfig.comparison.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoGroupFilterItemComponent.prototype, "hasSingleComparison", {
        get: function () {
            var filterConfig = AutoGroupFilterConfig[this.autoGroupFilter.type];
            return this.operatorList.length > 0 && filterConfig && filterConfig.comparison.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    AutoGroupFilterItemComponent.prototype.getFirstFilterValues = function (filterType) {
        var _this = this;
        if (!filterType) {
            return [];
        }
        var filterConfig = AutoGroupFilterConfig[filterType];
        if (!filterConfig || filterConfig.numOfCol === AutoGroupFilterList.singleValueColumn) {
            return [];
        }
        return AutoGroupFilterList.audienceOperatorList.map(function (item) { return ({
            id: item.id,
            name: _this.translate.instant('new_group_settings.auto_group_filters.audiencer_operator_dropdown', { operatorItem: item.value }),
            value: _this.translate.instant('new_group_settings.auto_group_filters.audiencer_operator_dropdown', { operatorItem: item.value })
        }); });
    };
    AutoGroupFilterItemComponent.prototype.validateFilters = function () {
        var errors = [];
        if (!this.autoGroupFilter.type) {
            errors.push(new ValidationError("auto_group_filter_" + this.autoGroupFilter.index, 'Incomplete filter'));
        }
        if (!this.autoGroupFilter.comparison) {
            errors.push(new ValidationError("filter_comparison_" + this.autoGroupFilter.index, 'Incomplete filter'));
        }
        if (this.hasMultipleValues && !this.autoGroupFilter.firstValue) {
            errors.push(new ValidationError("first_filter_value_" + this.autoGroupFilter.index, 'Incomplete filter'));
        }
        if ((Array.isArray(this.autoGroupFilter.secondValue) && this.autoGroupFilter.secondValue.length === 0) || this.autoGroupFilter.secondValue === null) {
            errors.push(new ValidationError("second_filter_value_" + this.autoGroupFilter.index, 'Incomplete filter'));
        }
        if (errors.length > 0) {
            this.errorMessage = this.translate.instant('new_group_settings.not_complete');
        }
        else {
            this.errorMessage = null;
        }
        return errors;
    };
    AutoGroupFilterItemComponent.prototype.checkAndClearPreviousErrors = function () {
        if (this.errorMessage) {
            this.validateFilters();
        }
    };
    AutoGroupFilterItemComponent.prototype.selectSecondFilterValue = function (evt) {
        this.checkAndClearPreviousErrors();
        if (this.autoGroupFilter.type === AutoGroupFilterEnum.PLATFORM) {
            var selectedPlatform = evt ? evt.name : null;
            this.changePlatformFilterEvent.emit(selectedPlatform);
        }
    };
    AutoGroupFilterItemComponent.prototype.clearAllFieldErrors = function () {
        this.filterBoxComponents.forEach(function (comp) { return comp.refreshErrors([[], true]); });
        this.errorMessage = null;
    };
    AutoGroupFilterItemComponent.prototype.updateWarningMessage = function (selectedPlatform) {
        if (!selectedPlatform) {
            this.warningMessage = null;
        }
        else {
            this.warningMessage = this.translate.instant('new_group_settings.warning_platform_only', { platform: selectedPlatform });
        }
    };
    return AutoGroupFilterItemComponent;
}());
export { AutoGroupFilterItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-filters/auto-group-filter-item/auto-group-filter-item.component.ts.pre-build-optimizer.js